module.exports = __webpack_public_path__ + "img/menu-light.00638ff4.svg";